import React, { useEffect, useState } from 'react';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from '../firebase';
import Avatar from '@mui/material/Avatar';


export default function Reviewsloader() {
  const [fetchData, setFetchData] = useState([]);
  const dbbref = collection(db, "reviews");
  const q = query(dbbref, orderBy('timestamp', 'desc'));

  // Helper function to format date
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Map rating to image path
  const getImageSrc = (rating) => {
    switch (rating) {
      case "5":
        return "/images/5stars.png";
      case "4":
        return "/images/4stars.png";
      case "3":
        return "/images/3stars.png";
      case "2":
        return "/images/2stars.png";
      case "1":
          return "/images/1stars.png";  
      // default:
      //   return "/images/5stars.png"; // fallback image
    }
  };

  // Fetching Data from Firestore
  const fetch = async () => {
    const snapshot = await getDocs(q);
    const fetchedData = snapshot.docs.map(doc => {
      const data = doc.data();

      // Assign image source based on rating
      const imageSrc = getImageSrc(data.rating);

      // Convert Firestore Timestamps to JavaScript Date objects
      if (data.timestamp && data.timestamp.toDate) {
        data.timestamp = data.timestamp.toDate();
      }

      return { id: doc.id, ...data, imageSrc }; // Add imageSrc to each data object
    });
    setFetchData(fetchedData);
  };

  useEffect(() => {
    fetch();
  }, []);

  return (
    <div>
      {fetchData.map(data => (
        <div key={data.id} className='relative left-2  md:left-[395px] bottom-0 md:bottom-48'>
          <div className="flex">
            <Avatar  sx={{ width: 16, height: 16 }} className="p-1 rounded-full mt-1 ring-2 ring-gray-300 dark:ring-gray-500"/>
            <div className="name font-bold  ml-2">{data.username}</div> 
            {data.imageSrc && (
              <img draggable="false"  className='m-2 pb-2 w-12 fill-yellow-600 cursor-pointer' src={data.imageSrc} alt={data.rating} />
            )}
            <div className="text text-gray-700 text-[11px] mt-1.5 ml-4">
              {data.timestamp ? formatDate(data.timestamp) : 'No date available'}
            </div>   
          </div>
          <div className="text text-gray-700 mt-2">{data.review}</div>         
          <hr className="mt-1 border-gray-200 sm:mx-auto lg:my-8" />            
        </div>
      ))}
    </div>
  );
}
